import {
  FEATURE_MATCH_DISPLAY,
  FEATURE_MATCH_STATUS,
  type FeatureMatchStatus,
} from '@/components/geomatching';

export function getFeatureMatchDisplayValue(status: FeatureMatchStatus): string {
  if (status === FEATURE_MATCH_STATUS.OK) return FEATURE_MATCH_DISPLAY.OK;
  if (status === FEATURE_MATCH_STATUS.NOT_FOUND) return FEATURE_MATCH_DISPLAY.NOT_FOUND;
  return FEATURE_MATCH_DISPLAY.NULL;
}
